import { LineString, MultiPolygon, Polygon } from "geojson";
import { determineSideAndDistance } from "./determineSideAndDistance";
import { GeoJSONFeature } from "mapbox-gl";
import turf from "../../../shared/utils/turf";

export const processPolygonAdjacentFeature = (
  road: LineString,
  feature: GeoJSONFeature,
) => {
  const building = feature.geometry as Polygon | MultiPolygon;

  const positions =
    building.type === "Polygon"
      ? building.coordinates[0].slice(1)
      : building.coordinates[0].flatMap((x) => x.slice(1));

  var nearestPosition: Record<"left" | "right", number> = {
    left: Infinity,
    right: Infinity,
  };

  for (const position of positions) {
    const point = turf.point(position);
    const relativePosition = determineSideAndDistance(point.geometry, road);

    if (!relativePosition) continue;

    nearestPosition[relativePosition.side] = Math.min(
      relativePosition.distance,
      nearestPosition[relativePosition.side],
    );
  }

  return nearestPosition;
};
